import {store} from 'Store/store.index';
import { getUserInfo } from "Api/fwApi/login"
import utils from "@foxit/utils";
export default {
  name: 'fw-convert-to-pdf',
  fragment: {
      template: `<div class="fw-convert-to-pdf-box">
                  <xbutton  class="fw-convert-to-pdf"
                            name='fw-convert-to-pdf' 
                            @tooltip
                            tooltip-title="转换为PDF"
                            text="转换为PDF">
                  </xbutton>
                  <span class="fx-icon fv__icon-toolbar-to-pdf"></span>
                </div>`,
      config: [{
          target: 'fw-convert-to-pdf',
          canBeDisabled: false,
          callback: () => {
            const hasSignIn = store.loginNewStore.isLogin
            if(!hasSignIn){
              store.loginNewStore.login()
              return true;
            }
            const config = {
              headers: {
                client: 'editCloud'
              },
              params: {
                token: utils.util.getQueryString("token")
              }
            }
            getUserInfo(config).then(res => {
              if (res.ret === 0) {
                store.userNewStore.setUserInfo(res.data);
                if(res.data.identity === "vip") {
                  store.convert.getConvertType("convert-to-pdf");
                  store.docsStore.getDocsModalType("convert");
                  store.saveFileNewStore.setIsShowFwDocs(true);
                } else {
                  store.common.getIsShowOpenMember(true);
                }
              }
            });
          }
      }]
  }
};